import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from 'react-modal';
import { adminLogout } from '../services/authService';

function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const currentPath = location.pathname;

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            borderRadius: '10px',
            padding: '0',
            maxWidth: '400px',
            width: '90%',
            backgroundColor: 'transparent'
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
        }
    };

    const handleLogoutClick = () => {
        setShowLogoutModal(true);
    };

    const closeLogoutModal = () => {
        setShowLogoutModal(false);
    };

    const handleConfirmLogout = async () => {
        try {
            await adminLogout();
            toast.success('Logged out successfully');
            closeLogoutModal();
            navigate('/admin/login');
        } catch (error) {
            console.error('Logout error:', error);
            toast.error('Logout failed. Please try again.');
        }
    };

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <>
        <div className="LeftSideDiv">
          <div className="logo">
            <img src={window.getPublicUrl('admin/images/admin-logo.svg')} alt="logo" />
          </div>
          <ul className="top-ul">
            <li>
              <a 
                href="#" 
                className={currentPath === '/admin/dashboard' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/admin/dashboard');
                }}
              >
                <span>
                  <img src={window.getPublicUrl('admin/images/dashboard.svg')} alt="logo" />
                </span>
                Dashboard
              </a>
            </li>
            <li>
              <a 
                href="#"
                className={currentPath === '/admin/customers' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/admin/customers');
                }}
              >
                <span>
                  <img src={window.getPublicUrl('admin/images/customer.svg')} alt="logo" />
                </span>
                Customers
              </a>
            </li>
            <li>
              <a
                href="#"
                className={currentPath === '/admin/daily-sales' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/admin/daily-sales');
                }}
              >
                <span>
                  <img src={window.getPublicUrl('admin/images/dashboard.svg')} alt="logo" />
                </span>
                Daily Sales
              </a>
            </li>
           <li>
              <a 
                href="#"
                className={currentPath === '/admin/blogs' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/admin/blogs');
                }}
              >
                <span>
                  <img src={window.getPublicUrl('admin/images/customer.svg')} alt="logo" />
                </span>
                Blogs
              </a>
            </li>
           
           
          </ul>
          <ul>
            <li className="mar-top">
              <a 
                href="#"
                className={currentPath === '/admin/settings' ? 'active' : ''}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation('/admin/settings');
                }}
              >
                
              </a>
            </li>
            <li>
              <a 
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogoutClick();
                }}
              >
                <span>
                  <img src={window.getPublicUrl('admin/images/logout.svg')} alt="logo" />
                </span>
                Logout
              </a>
            </li>
          </ul>
        </div>

        {/* Logout Confirmation Modal */}
        <Modal
            isOpen={showLogoutModal}
            onRequestClose={closeLogoutModal}
            style={customStyles}
            contentLabel="Logout Confirmation"
        >
            <div className="paymentsuccess">
                <div className="modal-content">
                    <div className="modal-header">
                        <button 
                            type="button" 
                            onClick={closeLogoutModal} 
                            className="close" 
                            data-dismiss="modal" 
                            aria-label="Close"
                        >
                            <img src={window.getPublicUrl('admin/images/close-icon.svg')} alt="Close" />
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Confirm Logout</h3>
                                <p className='mb-0'>Are you sure you want to logout? You will need to login again to access the admin panel.</p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0 pt-0">
                        <button
                            type="button"
                            className="btn  me-2"
                            onClick={closeLogoutModal}
                                  style={{
                                backgroundColor: 'transparent',
                              border: '0.5px solid rgba(217, 217, 217, 1)',
                                color: '#000'
                            }}
                           
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn  get-sim"
                            onClick={handleConfirmLogout}
                            style={{
                                backgroundColor: 'rgba(255, 116, 0, 1)',
                                color: '#fff'
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
        </>
    );
}

export default Sidebar;
